<oui-button *ngIf="!isLoading" type="icon" color="secondary" (click)="onDelete()"
  ><oui-icon>delete</oui-icon></oui-button
>
<div class="flex-horizontal flex-center justify-center" *ngIf="isLoading">
  <oui-loading size="small"></oui-loading>
</div>
